import React, { FC } from 'react'
import { Link } from 'react-router-dom'

import { DatePickerWithNavigation, Icon, IconColor, IconName } from 'Components'
import { routes } from 'Config'
import { registrationDateSelector } from 'ReduxStore/coreBackendUser'
import { useAppDispatch, useAppSelector } from 'ReduxStore/hooks'
import { currentJournalDateSelector, setJournalDateAction } from 'ReduxStore/journalDay'

const JournalHeader: FC = () => {
  const dispatch = useAppDispatch()

  const date = useAppSelector(currentJournalDateSelector)

  const registrationDate = useAppSelector(registrationDateSelector)

  const onChangeDate = (newDate: Date | null): void => {
    if (newDate) {
      dispatch(setJournalDateAction(newDate))
    }
  }

  return (
    <div className="journal-header mb-3">
      <div className="journal-header-actions journal-header-actions-start">
        <Link to={routes.inspiration.recipes} title="Rezepte" className="journal-header-action">
          <Icon name={IconName.book} color={IconColor.GRAY_1} />
        </Link>

        <Link to={routes.myEatables.index} title="Mein Essen" className="journal-header-action">
          <Icon name={IconName.utensils} color={IconColor.GRAY_1} />
        </Link>

        <Link to={routes.myEatables.favoritesOverview} title="Favoriten" className="journal-header-action">
          <Icon name={IconName.heart} color={IconColor.GRAY_1} />
        </Link>
      </div>

      <DatePickerWithNavigation currentDate={date} onChange={onChangeDate} rangeAllowed={{ from: registrationDate }} />

      <div className="journal-header-actions journal-header-actions-end">
        <Link to={routes.analytics.macronutrientBreakdown} title="Nährwertdiagramm" className="journal-header-action">
          <Icon name={IconName.piechart} color={IconColor.GRAY_1} />
        </Link>

        <Link to={routes.analytics.energyHistory} title="Kalorienbilanz" className="journal-header-action">
          <Icon name={IconName.barchart} color={IconColor.GRAY_1} />
        </Link>

        <Link to={routes.analytics.energyDistribution} title="Mahlzeitenverteilung" className="journal-header-action">
          <Icon name={IconName.clock} color={IconColor.GRAY_1} />
        </Link>

        <Link to={routes.settings.index} title="Einstellungen" className="journal-header-action">
          <Icon name={IconName.cog} color={IconColor.GRAY_1} />
        </Link>
      </div>
    </div>
  )
}

export default JournalHeader
